import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="footer light">
      {String.fromCharCode(169)} Copyright, GENCE LUCIEN {currentYear}
    </div>
  );
};

export default Footer;
